import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useFormikContext } from 'formik';
import * as enums from '~/const/enums'

type Option<T> = enums.Option<keyof T>
interface AutoCompleteProps<T> {
  label?: string;
  name: string;
  disabled?: boolean;
  items: Option<T>[];
  value?: keyof T;
  width?: number;
  disableClearable?: boolean;
}

export const Select = <T, K>(props: AutoCompleteProps<T>) => {
  const { setFieldValue } = useFormikContext();
  const value = props.items.find((item) => item.value === props.value) || null

  return (
    <Autocomplete
      onChange={(_, val) => {
        setFieldValue(
          props.name,
          val?.value
        );
      }}
      value={value}
      options={props.items}
      disabled={props.disabled}
      getOptionLabel={(o) => o?.label}
      disableClearable={props.disableClearable}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={props.label}
          style={{ width: props.width ? `${props.width}px` : '' }}
        />
      )}
    />
  );
};

export default Select